import { EMPTY_CELL } from '@/shared/constants'

import { compact, fixed, hasFigure } from './numberFormat'

/**
 * A figure in a grid: thousands separated and exactly `digits` decimals, so a column of
 * them lines up (`1200` → `1,200`; at two digits `1,200.00`). `null`, `undefined` and
 * `NaN` are `—`.
 *
 * A number that should drop its trailing zeros is `formatDecimal`.
 */
export function formatNumber(
  value: number | null | undefined,
  digits = 0
): string {
  if (!hasFigure(value)) return EMPTY_CELL

  return fixed(digits).format(value)
}

/**
 * The same count shortened to fit a narrow column: `393415` → `393.4K`, `1_200_000` → `1.2M`.
 * `null` → `—`. Pair it with `formatNumber` in a `title` so the exact figure is one hover
 * away — and decide **where** to start shortening at the call site: this one always does.
 */
export function formatCompact(value: number | null | undefined): string {
  if (!hasFigure(value)) return EMPTY_CELL

  return compact().format(value)
}
